import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import SweetAlert from 'sweetalert-react';

import SearchInput from 'components/SearchModal/SearchInput';

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
  NotificationSlider,
  GlassWidgetPanel,
} from 'C4';
import { storageKeys, bgVideo } from 'settings';

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '1993-01-01',
      appId: -1,
      userStatus: 'startTraining',
      noAgent: false,
      logo: null,
      landingQuote: null,
      firstName: null,
      lastName: null,
      email: null,
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        if (res.response.training_graduated) {
          return this.setState({
            userStatus: 'graduated',
            firstName: res.response.first_name,
            lastName: res.response.last_name,
            email: res.response.email,
          });
        }
        if (res.response.training_started) {
          return this.setState({
            userStatus: 'continueTraining',
            firstName: res.response.first_name,
            lastName: res.response.last_name,
            email: res.response.email,
          });
        }
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    // if (!localStorage.getItem('viewedPopup2')) {
    //   localStorage.setItem('viewedPopup2', true);
    //   setTimeout(() => {
    //     document.getElementById('waves').click();
    //   }, 1000);
    // }
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      StorageHandler.load(storageKeys.user).then((user) => {
        if (user && user.response.sales_companion_registered === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;

          APIHandler.updateUser(appId, obj.response.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.response.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        }
      });
    });

    this.getAppInfo();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logo,
        landingQuote: appInfo.landing_quote,
      });
    }
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages,
    ).then((res) => {
      if (res && res.missed_items && res.missed_items[0]) {
        this.setState({ unreadMessageCount: res.missed_items[0].count });
      }
    });
  }

  render() {
    const {
      unreadMessageCount,
      appId,
      userStatus,
      noAgent,
      logo,
      landingQuote,
      firstName,
      lastName,
      email,
    } = this.state;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}

        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                {logo && <img src={logo} className="homeLogo" alt="logo" />}
                <h1>{landingQuote}</h1>
                <div className="homeView__title--line" />
                <div className="homeView__title--action">
                  <SearchInput />
                </div>
              </div>
            </div>
          )}
        </Spring>
        <div className="top-bar" />
        <div className="bottom-bar" />
        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
        {/* <ToastContainer
          draggablePercent={60}
          autoClose={false}
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange
          draggable
        /> */}

        <div className="homeView__glassWidgets">
          <GlassWidgetPanel
            appId={appId}
            position="left"
            firstName={firstName}
            lastName={lastName}
            email={email}
          />
        </div>
        {/* <NotificationSlider appId={appId} middle right /> */}
      </div>
    );
  }
}
